import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const DropCountdown = ({ dropAt, slug }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!dropAt) return null;
  const target = new Date(dropAt).getTime();
  if (Number.isNaN(target) || target <= now) return null;
  const s = Math.floor((target - now) / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const dateLabel = new Date(dropAt).toLocaleDateString("en-US", {
    weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
  return (
    <div className="border border-white/25 px-4 py-4 mt-4" data-testid={`drop-countdown-${slug}`}>
      <p className="font-mono-label text-white/40">NEXT DROP IN</p>
      <p className="font-display text-2xl lg:text-3xl mt-1 tabular-nums" data-testid="drop-countdown-timer">
        {d > 0 ? `${d}D ` : ""}{pad(h)}H {pad(m)}M {pad(sec)}S
      </p>
      <p className="font-mono-label text-white/40 mt-1.5">{dateLabel.toUpperCase()}</p>
    </div>
  );
};
